var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('div',{attrs:{"id":"chart"}},[_c('apexchart',{ref:"apexchart1",attrs:{"type":"scatter","options":_vm.chartOptions,"series":_vm.series,"height":"250"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }